import axios from "./axios";

//行程统计数据
export const queryWebDigitalRec=(data)=>{
	return axios({
		act: "v1/queryWebDigitalRec",
		method: "post",
		data: data
	});
}

//行程详情
export const queryWebDigitalRecDetail=(data)=>{
	return axios({
		act: "v1/queryWebDigitalRecDetail",
		method: "post",
		data: data
	});
}


//单车仪表盘数据
export const QuerySwitchStatus = (data) => {
	return axios({
		act: "v1/QuerySwitchStatus",
		method: "post",
		data,
	});
};
export const topaffiche = (data) => {
	return axios({
		act: "v3/basic/topaffiche",
		method: "get",
		params: data
	});
};
export const queryVideoDeviceNo = (data) => {
	return axios({
		act: "v1/queryVideoDeviceNo",
		method: "post",
		data,
	});
};
//查询记录仪终端编号
export const queryVideoDeviceNoRecorder = (data) => {
	return axios({
		act: "v1/queryVideoDeviceNoRecorder",
		method: "post",
		data,
	});
};

//查询车辆电池日分析
export const queryVehicleBatteryDaily = (data) => {
	return axios({
		act: "v3/vehicle/battery_analysis",
		method: "get",
		params: data
	});
};
//查询车辆32960数据
export const queryVehicle32960Data = (data,responseType) => {

	return axios({
		act: "v3/vehicle/vehicle_32960",
		method: "get",
		params: data,
		responseType: responseType || 'json'
	});
};

//查询车辆速度里程分析曲线
export const queryVehicleSpeedMileageAnalysisCurve = (data) => {
	return axios({
		act: "v3/vehicle/vehicle_speed_mileage_analysis_curve",
		method: "get",
		params: data
	});
};


//查询车辆基本信息
export const queryVehicleBaseInfo = (data) => {
	return axios({
		act: "v1/queryVehicleBaseInfo",
		method: "post",
		data
	});
};
//查询车辆新能源信息
export const queryVehicleNewEngineBaseInfo = (data) => {
	return axios({
		act: "v1/queryVehicleNewEngineBaseInfo",
		method: "post",
		data
	});
};
export const queryRealTimeVehicleInfo = (data) => {
	return axios({
		act: "v1/queryRealTimeVehicleInfo",
		method: "post",
		data
	});
};

//查询菜单信息
export const queryMenuInfo = (data) => {
	return axios({
		act: "v1/queryMenuInfo",
		method: "post",
		data
	});
};

//查询长期停滞记录
export const queryLongStayRec = (data,responseType) => {
	return axios({
		act: "v1/queryLongStayRec",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};

//查询电池数据
export const QueryAbroadCANBattery = (data,responseType) => {
	return axios({
		act: "v1/QueryAbroadCANBattery",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};

//查询整车数据
export const QueryAbroadCANVehicle = (data,responseType) => {
	return axios({
		act: "v1/QueryAbroadCANVehicle",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};

//查询电机数据
export const QueryAbroadCANMotor = (data,responseType) => {
	return axios({
		act: "v1/QueryAbroadCANMotor",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};

export const queryVideoDeviceNoByTime = (data,responseType) => {
	return axios({
		act: "v1/queryVideoDeviceNoByTime",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};
